<template>
	<div
		:id="id"
		:name="name"
		:class="inputClassListLive"
		:title="value"
	>
		{{ value }}
	</div>
</template>

<script>
	import { baseInput } from './../mixins/index.js';

	export default {
		name: 'PlainText',

		mixins: [baseInput]
	};
</script>

<style scoped>

</style>
